import React from 'react';
import ErrorBoundaryFallback from './error-boundary-fallback';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.onError) {
      this.props.onError({ originalError: error });
    }
  }

  render() {
    if (this.state.hasError) {
      const Fallback = this.props.FallbackComponent || ErrorBoundaryFallback;
      return <Fallback msg={this.state.error?.message} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
